export const DEMO_RESUME = `Sarah Chen
sarah.chen@email.com • (415) 555-0192 • San Francisco, CA • linkedin.com/in/sarah-chen-pm

PROFESSIONAL SUMMARY
Results-driven Senior Product Manager with 9 years of experience building B2B SaaS products from 0 to $50M+ ARR. Led cross-functional teams of 20+ to ship 0-to-1 features and redesign core workflows. Proven track record of reducing customer churn by 31% and accelerating enterprise time-to-value through data-driven experimentation and strategic roadmap prioritization.

PROFESSIONAL EXPERIENCE

Meridian SaaS — San Francisco, CA
Senior Product Manager — Jan 2020 – Present
Oversaw product strategy for Meridian's enterprise analytics suite, managing a portfolio of 4 product lines generating $28M ARR.
• Launched ML-powered anomaly detection feature adopted by 87% of enterprise tier within 6 months, generating $4.2M incremental ARR
• Reduced customer churn by 31% by redesigning onboarding flow using Jobs-to-be-Done framework and A/B testing 12 variants across 8,000 accounts
• Built and maintained 18-month roadmap aligned to $100M ARR target; presented quarterly to board and C-suite stakeholders
• Managed 3 associate PMs and collaborated with 6 engineering squads across US and EMEA time zones
• Drove integration partnerships with Salesforce, HubSpot, and Snowflake adding 2,400 new SMB accounts in 12 months

Nexlify Inc — Austin, TX
Product Manager — Mar 2017 – Dec 2019
• Shipped core collaboration module (real-time editing, commenting, version history) that increased DAU by 44% quarter-over-quarter
• Defined and tracked OKRs across 3 product areas; improved NPS from 32 to 61 over 18 months through continuous discovery cycles
• Partnered with Sales to create product-led growth motion reducing CAC by 22% and shortening sales cycle by 6 weeks
• Ran 200+ customer discovery interviews and 14 usability studies that shaped 2-year product vision
• Led pricing redesign expanding average contract value by $18K per enterprise account

DataBridge Technologies — Chicago, IL
Associate Product Manager — Jun 2015 – Feb 2017
• Supported launch of API marketplace connecting 50+ third-party data providers, reaching 500 developer sign-ups in first 90 days
• Authored 40+ PRDs and managed backlog for 2 engineering squads with zero critical sprint blockers in final 6 months
• Reduced bug backlog by 65% through structured triage and sprint planning improvements

EDUCATION
University of Michigan — B.S. Computer Science, Minor in Business Administration — May 2015
Stanford Continuing Education — Product Management Certificate — 2018

CORE COMPETENCIES
• Product Strategy & Roadmapping • OKRs & KPI Definition • Agile/Scrum • User Research & Discovery
• A/B Testing & Experimentation • Cross-functional Leadership • Stakeholder Management • B2B SaaS
• SQL & Data Analysis • Customer Journey Mapping • Go-to-Market Strategy • Pricing & Packaging`;

export const DEMO_JOB_DESCRIPTION = `VP of Product — CloudPilot Inc.

About CloudPilot:
CloudPilot is a Series C B2B SaaS company ($85M raised) helping mid-market businesses automate and optimize their cloud infrastructure costs. We serve 2,400+ customers across North America and Europe and are scaling from $40M to $100M ARR.

The Role:
We are looking for a VP of Product to own the entire product roadmap and lead our 8-person product team. You will report directly to the CEO and work closely with Engineering, Sales, and Customer Success to define and ship the features that will take us to $100M ARR.

Key Responsibilities:
• Define and execute product strategy aligned to our $100M ARR growth target
• Build and mentor a high-performing product team of 8 PMs and 2 researchers
• Drive enterprise adoption through platform integrations (Snowflake, AWS, Azure)
• Lead product-led growth initiatives to reduce sales cycle length by 30%
• Own pricing, packaging, and go-to-market for new product lines
• Present roadmap and vision to board, investors, and enterprise customers
• Partner with Customer Success to reduce churn and improve time-to-value
• Champion experimentation culture: A/B testing, feature flags, rapid iteration

Requirements:
• 7+ years product management experience, 2+ years in senior leadership
• Track record of scaling B2B SaaS products to $50M+ ARR
• Strong data analysis skills (SQL preferred)
• Experience with enterprise customer discovery and stakeholder management
• Excellent communication skills for board-level presentations
• Background in ML/AI product development a plus
• Experience with cloud infrastructure or DevOps products preferred`;

export const DEMO_APPLICATION_INFO = {
  company: 'CloudPilot Inc.',
  targetJobTitle: 'VP of Product',
  hiringManager: 'Alex Rivera',
  title: 'VP of Product',
  address: 'San Francisco, CA',
  date: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
};
